import React, { useState, useEffect } from "react";
import { baseUrl } from '../../shared.js';
import '../App.css';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { BookingDateRange } from '../../components/ui';
  
function EditBooking({bookingItem, onSuccess}) {
  const [changed, setChanged] = useState(false);
  // startDate/returnDate arrive as display text ("Tue 14th October 2026"), which
  // neither dayjs nor the DATE column can read. SD/RD are the same dates as
  // YYYY-MM-DD, so seed both from those and keep the four in step.
  const [modBooking, setModBooking] = useState({
    ...bookingItem,
    startDate: bookingItem?.SD || '',
    returnDate: bookingItem?.RD || '',
  });
  var [statusList, setStatusList] = useState([]);
  const [statusLoaded, setStatusLoaded] = useState(false);
  const [open, setOpen] = React.useState(false);
 

  const handleClickOpen = () => {
    setOpen(true);
  }; 

  const handleClose = () => {
    setOpen(false);
  };

useEffect(()=> {
  console.log(changed);
  console.log('Mod Booking ',modBooking);
});



const [responseOpen, setResponseOpen] = React.useState(false);
const [message, setMessage] = useState('');
const [hyperlink, setHyperLink] = useState('');

                               
useEffect(()=> {
  if (localStorage.getItem('adminFunctions') === '1' ) {
    
  } else {
    window.location.href='/'
  }
},[]);

const handleResponseClose = () => {
    setResponseOpen(false);
    onSuccess()
};

  useEffect(() => {
    const url = baseUrl + 'status/list/';
      fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
          console.log('status List: ', json)
            if(json.status === 200) {
            setStatusList(json.data);
            } else {
              setStatusList([])  
            }
          setStatusLoaded(true);
      })
      .catch((err) => {
         console.log(err.message);
      });
    },[])
    

async function editBooking(e) {
  e.preventDefault();
  const url = baseUrl + 'hire/edit';
  await fetch(url, {
      method: 'PATCH',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(modBooking),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setHyperLink(data.hyperlink)
          setResponseOpen(true);
          } else {
            setMessage(data.message || 'The booking could not be updated.');
            setHyperLink('');
            setResponseOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setResponseOpen(true);
        });
}

async function deleteBooking(e) {
  e.preventDefault();
  const url = baseUrl + 'hire/delete';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(modBooking),
  })
  .then((data) => {
    onSuccess()
        });
}

return (
    <div>
    <React.Fragment>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="confirmDeleteTitle">
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmDeleteDesc">
          Are you sure you want to delete the Booking?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={deleteBooking}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
      <React.Fragment>
      <Dialog
        open={responseOpen}
        onClose={handleResponseClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmResponseTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmResponseDesc">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {hyperlink ? <Button onClick={(e) => {window.location.href=hyperlink}}>Go To Booking</Button> : null}
          <Button onClick={handleResponseClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    <div className="createItem">
    <p style={{fontWeight: "bolder", fontSize: "20px", color: "darkorange"}}>Edit Booking</p>
    <p style={{fontSize: "15px"}}> Update below fields to<br />edit the Booking in the System.</p>
     <Box 
          margin="dense">
          <TextField 
         fullWidth
           margin="dense"
           id="bookingId" 
           InputProps={{
             readOnly: true,
           }}
           defaultValue={modBooking.id}
           label="bookingId" 
           variant="outlined" 
           type="text" 
         />
         <TextField 
        fullWidth
          margin="dense"
          id="itemNo" 
          InputProps={{
            readOnly: true,
          }}
          defaultValue={modBooking.itemNo}
          label="Item Number" 
          variant="outlined" 
          type="text" 
        />
        <TextField 
       fullWidth
         margin="dense"
         id="company" 
         InputProps={{
           readOnly: true,
         }}
         defaultValue={modBooking.company}
         label="Company" 
         variant="outlined" 
         type="text" 
       />
     <BookingDateRange
       itemNo={bookingItem?.itemNo}
       bookingId={bookingItem?.id}
       initialStart={bookingItem?.SD}
       initialEnd={bookingItem?.RD}
       onChange={({ startDate, returnDate }) => {
         setChanged(true);
         // SD/RD gate the Update button; startDate/returnDate are what the API writes.
         setModBooking((b) => ({ ...b, startDate, returnDate, SD: startDate, RD: returnDate }));
       }}
     />
              <FormControl
              margin="dense"
         fullWidth>
              <InputLabel shrink htmlFor="bookingStatusTitle">
             Booking Status
           </InputLabel>
              <Select
                native
                label="bookingStatus"
                inputProps={{
                  id: 'bookingStatusTitle',
                }}
                fullWidth
                onChange={(e) => {
                  setChanged(true);
                  setModBooking({
                    ...modBooking,
                    statusId: e.target.value,
                 });
                  }}>
                  <option selected disabled>Current: {modBooking.status}</option>
                {
                statusList?.map((statusList) => {
                return <option value={statusList?.id} key={statusList?.id}>{statusList?.status}</option>
              })
            }
        </Select>
        </FormControl>
        <TextField 
       fullWidth
         margin="dense"
         id="poNumber" 
         defaultValue={modBooking.poNumber}
         onChange={(e) => {
           setChanged(true);
           setModBooking({
             ...modBooking,
             poNumber: e.target.value,
          })}}
         label="Purchase Order Number" 
         variant="outlined" 
         type="text" 
       />
       <TextField 
      fullWidth
        margin="dense"
        id="invoiceNumber" 
        defaultValue={modBooking.invoiceNumber}
        onChange={(e) => {
          setChanged(true);
          setModBooking({
            ...modBooking,
            invoiceNumber: e.target.value,
         })}}
        label="Invoice Number" 
        variant="outlined" 
        type="text" 
      />
     </Box>
     <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mt: 2 }}>
       <Button variant="outlined" color="error" onClick={handleClickOpen}>
         Delete Booking
       </Button>
       <Button variant="contained"
         onClick={editBooking}
         disabled={ !modBooking.SD || !modBooking.RD|| !modBooking.status }
       >
         Update Booking
       </Button>
     </Box>
        </div>
  </div>
)};
       
export default EditBooking